<template>
    <el-popover
        placement="bottom"
        title="主题"
        width="300"
        trigger="click"
        >
        <i class="iconfont iconhuanfu" slot="reference"></i>
        <slot name="reference">
            <el-tabs v-model="activeName">
                <el-tab-pane label="主题色" name="first">
                    <ul class="colorUl">
                        <li 
                            v-for="t in themeList" 
                            :key="t.id" 
                            :style="{background: t.color}"
                            @click="themeChange(t)"
                            >
                        </li>
                    </ul>
                </el-tab-pane>
            </el-tabs>
        </slot>
    </el-popover>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
    data() {
        return {
            activeName: 'first',
        }
    },
    computed: {
        ...mapState ({
            themeList: state => state.themeList
        }),
        
    },
    mounted() {
        console.log(this.themeList)
    },

    methods: {
        ...mapActions(["themeChange"])  
    },
}
</script>